<template>
  <button
    aria-haspopup="dialog"
    aria-label="View Custom Colors"
    class="link-med"
    :class="{ 'divider padding-right-xs margin-right-xs': orderSwatches }"
    @click.stop="openCustomColorsDrawer"
  >
    View Custom Colors
  </button>
</template>

<script setup>
import { defineAsyncComponent, markRaw } from 'vue';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useSlideout } from '~/composables/utils/useSlideout';

const { orderSwatches } = useFeatureEligibility();
const { showSlideout } = useSlideout();

const openCustomColorsDrawer = () => {
  showSlideout({
    // TODO:
    id: 'View Custom Colors',
    title: 'Custom Colors',
    component: markRaw(
      defineAsyncComponent(
        () => import(/* webpackChunkName: "ViewCustomColorsInfo" */ '../slideoutContent/viewCustomColors/ViewCustomColorsInfo.vue'),
      ),
    ),
  });
};
</script>

<style lang="scss" scoped>
.divider {
  border-right: 1px solid $gray-3-color;
  border-radius: unset;
}
</style>
